import React from 'react';
import PropTypes from 'prop-types';
import { featureCollection, lineString } from '@turf/helpers';
import GeoJSONLayer from './GeoJSONLayer';
import { toLngLat } from '../../../lib/map_helpers';

const arrowImageId = 'direction-arrow';
const arrowPixelRatio = 2;

// Drawn on a canvas so the image exists synchronously, before the symbol layer referencing it is added.
// It points east, the direction MapLibre aligns icons to along a line.
const drawArrow = () => {
  const size = 12 * arrowPixelRatio;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext('2d');
  context.strokeStyle = '#444444';
  context.lineWidth = 1.5 * arrowPixelRatio;
  context.lineCap = 'round';
  context.lineJoin = 'round';
  context.beginPath();
  context.moveTo(size * 0.35, size * 0.25);
  context.lineTo(size * 0.65, size * 0.5);
  context.lineTo(size * 0.35, size * 0.75);
  context.stroke();

  return context.getImageData(0, 0, size, size);
};

const arrowImages = { [arrowImageId]: { draw: drawArrow, pixelRatio: arrowPixelRatio } };
const arrowLayer = {
  type: 'symbol',
  layout: {
    'symbol-placement': 'line',
    'symbol-spacing': 100,
    'icon-image': arrowImageId,
    'icon-allow-overlap': true
  }
};

export default class Polyline extends React.Component {
  data() {
    if (this.props.positions.length < 2) return featureCollection([]);

    return lineString(this.props.positions.map(toLngLat));
  }

  paint() {
    const { color, weight, opacity, dashArray } = this.props;
    const paint = { 'line-color': color, 'line-width': weight, 'line-opacity': Number(opacity) };

    // dashArray is given in pixels, MapLibre measures dashes in line widths
    if (dashArray) paint['line-dasharray'] = dashArray.map((length) => length / weight);

    return paint;
  }

  render() {
    const lineLayer = { type: 'line', paint: this.paint(), layout: { 'line-cap': 'round', 'line-join': 'round' } };

    if (!this.props.withDirectionArrows) return <GeoJSONLayer data={this.data()} layers={[lineLayer]} />;

    return <GeoJSONLayer data={this.data()} layers={[lineLayer, arrowLayer]} images={arrowImages} />;
  }
}

Polyline.defaultProps = {
  color: '#3388ff',
  weight: 3,
  opacity: 1,
  withDirectionArrows: false
};

Polyline.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.array, PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number })])
  ).isRequired,
  color: PropTypes.string,
  weight: PropTypes.number,
  opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dashArray: PropTypes.arrayOf(PropTypes.number),
  withDirectionArrows: PropTypes.bool
};
